import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Button, Form, Tabs } from "antd";
// import { message, Tabs, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { openNotification } from "../../../shared/notification";
import { post, uploadFile } from "../../../services";
// Components
import Basic from "../form/basic";
import Video from "../form/video";
import Features from "../form/features";
import Reviewer from "../form/reviewer";
import Gallery from "../form/gallery";
import Modal from "../form/upload-status-modal";
import { transformValueSwitch } from "../../../utils/property-status";

const AddBlogs = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [propertyStatusMessage, setPropertyStatusMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState();
  const [slug, setSlug] = useState("");
  // All Uploaded Files
  const [fileList, setFileList] = useState([]);
  // Selected Agents - if option is selected to show box
  const [selectedAgents, setSelectedAgents] = useState("None");
  // add selected Address
  const [selectedAdddress, setSelectedAdddress] = useState({
    lat: "",
    long: "",
    address: "",
  });
  // upload modal status
  const [uploadStatus, setUploadStatus] = useState("");
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const showStatusModal = () => {
    setIsStatusModalOpen(!isStatusModalOpen);
  };

  // navigation
  const navigation = [
    {
      key: "1",
      label: "Basic",
      children: (
        <Basic
          selectedAdddress={selectedAdddress}
          setSelectedAdddress={setSelectedAdddress}
          propertyStatusMessage={propertyStatusMessage}
          setPropertyStatusMessage={setPropertyStatusMessage}
          slug={slug}
          setSlug={setSlug}
          timestamp={false}
        />
      ),
    },
    {
      key: "2",
      label: "Gallery",
      children: (
        <Gallery
          fileList={fileList}
          setFileList={setFileList}
          information={null}
        />
      ),
    },
    {
      key: "3",
      label: "Video",
      children: <Video />,
    },
    {
      key: "4",
      label: "Features",
      children: <Features />,
    },
    {
      key: "5",
      label: "Agent & Reviewer",
      children: (
        <Reviewer
          selectedAgents={selectedAgents}
          setSelectedAgents={setSelectedAgents}
        />
      ),
    },
  ];

  // uploadFiles handler API
  const uploadFiles = async (file) => {
    try {
      const response = await uploadFile("/getSignUrlForUpload", { file: file });
      return response?.data?.publicUrl;
    } catch (error) {
      openNotification("Error", "File upload failed.");
      return false;
    }
  };

  // uploadAllFiles handler to upload array
  const uploadAllFiles = async (files) => {
    try {
      // Map over the files and upload each one using promises
      const uploadPromises = files.map(async (item) => {
        const file = item.originFileObj;
        // To Chnage file name
        const now = new Date();
        const formattedTime = now.toISOString().replace(/[-:TZ.]/g, ""); // Remove special characters
        const milliseconds = now.getMilliseconds().toString().padStart(3, "0");
        const extension = file.name.split(".").pop();
        const baseName = file.name
          .substring(0, file.name.lastIndexOf("."))
          .replace(/[^a-zA-Z0-9]/g, ""); // remove non-alphanumeric
        const newName = `${baseName}_${formattedTime}${milliseconds}.${extension}`;
        // Create a new File object with the same contents and modified name
        const renamedFile = new File([file], newName, {
          type: file.type,
          lastModified: file.lastModified,
        });
        // Upload the renamed file
        const uploadedUrl = await uploadFiles(renamedFile);

        // return uploadFiles(renamedFile);
        return {
          url: uploadedUrl,
          alt_title: item.alt_title || "",
          meta_title: item.meta_title || "",
          meta_description: item.meta_description || "",
        };
      });

      // Wait for all the upload promises to complete
      const uploadResults = await Promise.all(uploadPromises);
      return uploadResults;
    } catch (error) {
      openNotification("Error", "One or more file uploads failed.");
      return [];
    }
  };

  const floorPlanImageHandler = async (floorPlan) => {
    let floorList = [];
    let floorImages = [];
    floorPlan?.map((item) => {
      floorList.push({ floorName: item?.floorName, floorPlanImage: "" });
      floorImages.push(item?.floorImage?.file);
    });
    openNotification("Uploading", "Please Wait To Upload All Floor Images");
    const uploadedFiles = await uploadAllFiles(floorImages);
    const updatedList = floorList.map((item, index) => ({
      ...item,
      floorPlanImage: uploadedFiles[index] || "",
    }));
    return updatedList;
  };

  // Submit Handler
  const onFinish = async (values) => {
    // Tab 1 Conditions
    if (activeTab === 1 && !selectedAdddress?.lat && !selectedAdddress?.long) {
      openNotification("Error", "Please Select Address in Map");
    }
    // Tab 2 ,3, 4 Conditions
    else if (
      activeTab === 1 ||
      activeTab === 2 ||
      activeTab === 3 ||
      activeTab === 4
    ) {
      setActiveTab(activeTab + 1);
    }
    // Tab 5 Conditions.
    else if (activeTab === 5 && values?.acceptTermsAndConditions === false) {
      openNotification("Error", "Please Accept Terms & Conditions");
    } else if (activeTab === 5) {
      const {
        bitrixProperty,
        offering_type,
        finishing_type,
        uae_emirate,
        publishing_status,
        listing_owner,
        listing_agent,
        rental_period,
        ...restValues
      } = values;
      // If Bitrix is selected, then the user must select some options (like Offering Type, Finishing Type, UAE Emirate).
      // if (!publishing_status) {
      //   setErrors(["Publishing Status is required in the Basic tab."]);
      //   return false;
      // }
      if (
        bitrixProperty &&
        (!offering_type || !finishing_type || !uae_emirate)
      ) {
        setErrors([
          "Please complete all required fields in the Basic tab — Offering Type, Finishing Type, and UAE Emirate — to proceed with saving in Bitrix.",
        ]);
        return openNotification(
          "Notification",
          "Please complete all required fields in the Basic tab — Offering Type, Finishing Type, and UAE Emirate — to proceed with saving in Bitrix."
        );
      }
      // to save record
      setLoader(true);
      // for uploading videos
      const videos = values?.videos?.some(
        (item) => Object.keys(item).length === 0 && item.constructor === Object
      )
        ? null
        : values?.videos;

      // for uploading images
      const originalFiles =
        fileList?.length > 0
          ? fileList?.map((img) => {
              return { ...img, file: img.originFileObj };
            })
          : [];

      // to check floor
      const shouldShowFloor =
        Array.isArray(values?.floorPlans) &&
        values?.floorPlans !== undefined &&
        values?.floorPlans?.length > 0 &&
        !(
          (values?.floorPlans?.length === 1 &&
            Object.keys(values?.floorPlans[0]).length === 0) ||
          (values.floorPlans[0].floorName === undefined &&
            values.floorPlans[0].floorImage === undefined)
        );

      // To Check if we have pictures then to upload it.
      if (originalFiles?.length > 0) {
        openNotification("Uploading", "Please Wait To Upload All Images");
        setUploadStatus("Gallery");
      }
      // to open a modal
      showStatusModal();
      const filesUrl =
        originalFiles?.length > 0 ? await uploadAllFiles(originalFiles) : [];

      if (shouldShowFloor) {
        setUploadStatus("Floor");
      }
      // To Check if we have floor plan pictures then to upload it.
      const floorPlans = shouldShowFloor
        ? await floorPlanImageHandler(values?.floorPlans)
        : [];

      const imagesPayload = filesUrl?.map((item) => {
        return {
          url: item?.url || "",
          altTitle: item.alt_title || "",
          metaData: {
            title: item.meta_title || "",
            description: item.meta_description || "",
            keywords: item.meta_keywords || "",
          },
        };
      });

      setUploadStatus("Final");

      const payload = {
        ...restValues,
        isPropertyUnPublished:
          publishing_status === "UNPUBLISHED" ? true : false,
        publishing_status: publishing_status ? publishing_status : "PUBLISHED",
        slug: values?.status
          ? slug + "-" + transformValueSwitch(values?.status)
          : slug,
        images: imagesPayload,
        latitude: selectedAdddress?.lat,
        longitude: selectedAdddress?.long,
        address: selectedAdddress?.address,
        videos: videos,
        floorPlans: floorPlans,
        status: values?.status || "",
        meta_title: [values?.meta_title],
        meta_keyword: [values?.meta_keyword],
        meta_description: [values?.meta_description],
        finishing_type: finishing_type,
        offering_type: offering_type,
        uae_emirate: uae_emirate,
        listing_owner: listing_owner,
        listing_agent: listing_agent,
        rental_period: rental_period,
      };
      post(`/property`, payload)
        .then(() => {
          form.resetFields();
          openNotification("Success", "Property created successfully");
          setLoader(false);
          navigate("/");
          showStatusModal();
        })
        .catch((error) => {
          setLoader(false);
          setIsStatusModalOpen(false);
          setErrors(error?.response?.data?.message);
          openNotification("Error", error?.response?.data?.message);
        });
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Add Property</title>
        <meta name="description" content="Add and manage properties" />
      </Helmet>
      {/* Modal */}
      <Modal
        isStatusModalOpen={isStatusModalOpen}
        setIsStatusModalOpen={setIsStatusModalOpen}
        showStatusModal={showStatusModal}
        uploadStatus={uploadStatus}
      />
      <div className="form_container">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            features: [
              "24/7 Security",
              "Balcony",
              "BBQ Area",
              "Central Cooling",
              "Central Heating",
              "Fire Alarm",
              "Gym",
              "Jogging Track",
              "Kids Pool",
              "Lawn",
              "Main Pool",
              "Marble Floors",
              "Parking",
              "Shared Gym",
              "Shared Pool",
              "Swimming Pool",
              "View of Water",
            ],
            floorPlans: [{}],
            videos: [{}],
            additionalDetails: [{}],
            agentInformationDisplay: "None",
          }}
        >
          {/* Tabs */}
          <Tabs
            defaultActiveKey={activeTab}
            activeKey={activeTab?.toString()}
            items={navigation}
            onChange={(e) => {
              setActiveTab(parseInt(e));
            }}
          />
          {/* Errors */}
          {errors && <div style={{ color: "red", fontSize: 14 }}>{errors}</div>}
          {/* Footer Buttons */}
          <Form.Item>
            <div className="form_submit pt-15">
              <Button
                className="back_button"
                onClick={() => {
                  setActiveTab(activeTab === 1 ? 1 : activeTab - 1);
                }}
                disabled={activeTab === 1}
              >
                Back
              </Button>

              <Button htmlType="submit" type="primary">
                {activeTab < 5 ? "Next" : loader ? "Please Wait..." : "Save"}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default AddBlogs;
